<template>
<div class="chapter">
<div class="inner_page">
<div class="sidebar">
<div class="sidebar1">
<div class="sidebar2">
<p class="linespace"> </p>
<h1 class="book-title"><a id="page_iii"></a><span class="small1">TO TRY</span><br/>MEN’S SOULS</h1>
<p class="image1"><img alt="Image" src="images/star.jpg"/></p>
<p class="sub-title"><span class="small1"><em>A NOVEL OF</em></span></p>
<p class="sub-title">GEORGE WASHINGTON</p>
<p class="sub-title"><span class="small1"><em>AND THE FIGHT FOR</em></span></p>
<p class="sub-title">AMERICAN FREEDOM</p>
<p class="image1"><img alt="Image" src="images/star.jpg"/></p>
<p class="author">N<span class="small">EWT</span> G<span class="small">INGRICH</span>,<br/>W<span class="small">ILLIAM</span> R. F<span class="small">ORSTCHEN</span><br/><span class="small"><em>AND</em></span><br/>A<span class="small">LBERT</span> S. H<span class="small">ANSER,</span></p>
<p class="author1"><em>contributing editor</em></p>
<p class="image1"><img alt="Image" src="images/star.jpg"/></p>
<p class="para"> </p>
<p class="editor"><span class="smallcaps">THOMAS DUNNE BOOKS<br/>ST. MARTIN’S PRESS <img alt="Image" src="images/pub.jpg"/> NEW YORK</span></p>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?84eabb4a